module.exports = __webpack_public_path__ + "static/media/11-9-16.bda4e35f.jpg";